'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.watchRemoteCreate = watchRemoteCreate;
exports.watchRemoteCreateSuccess = watchRemoteCreateSuccess;
exports.watchLoadMessagesWorker = watchLoadMessagesWorker;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _socket = require('../actions/socket');

var socketActions = _interopRequireWildcard(_socket);

var _messages = require('../actions/messages');

var messagesActions = _interopRequireWildcard(_messages);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = [loadMessagesWorker, callCreateWorker, publishCreationWorker, watchRemoteCreate, watchRemoteCreateSuccess, watchLoadMessagesWorker].map(regeneratorRuntime.mark);

/**
 *
 */
function loadMessagesWorker(_ref) {
	var payload = _ref.payload;
	var discussionId = _ref.meta.discussionId;
	var actionCreator;
	return regeneratorRuntime.wrap(function loadMessagesWorker$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					actionCreator = function actionCreator(_ref2) {
						var messages = _ref2.messages;
						return messagesActions.initialize(discussionId, messages);
					};

					_context.next = 3;
					return (0, _effects.put)(socketActions.call('rpc/discussions/' + discussionId + '/messages/get', actionCreator, payload));

				case 3:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked[0], this);
}

/**
 *
 */
function callCreateWorker(_ref3) {
	var payload = _ref3.payload;
	var discussionId = _ref3.meta.discussionId;
	var actionCreator;
	return regeneratorRuntime.wrap(function callCreateWorker$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					actionCreator = function actionCreator(message) {
						return messagesActions.remoteCreateSuccess(discussionId, message);
					};

					_context2.next = 3;
					return (0, _effects.put)(socketActions.call('rpc/discussions/' + discussionId + '/messages/create', actionCreator, payload));

				case 3:
				case 'end':
					return _context2.stop();
			}
		}
	}, _marked[1], this);
}

/**
 *
 */
function publishCreationWorker(_ref4) {
	var message = _ref4.payload.message;
	var discussionId = _ref4.meta.discussionId;
	return regeneratorRuntime.wrap(function publishCreationWorker$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _effects.put)(socketActions.publish('pubsub/discussions/' + discussionId, 'messages/create', message));

				case 2:
				case 'end':
					return _context3.stop();
			}
		}
	}, _marked[2], this);
}

/**
 *
 */
function watchRemoteCreate() {
	return regeneratorRuntime.wrap(function watchRemoteCreate$(_context4) {
		while (1) {
			switch (_context4.prev = _context4.next) {
				case 0:
					_context4.next = 2;
					return (0, _reduxSaga.takeEvery)(messagesActions.REMOTE_CREATE, callCreateWorker);

				case 2:
				case 'end':
					return _context4.stop();
			}
		}
	}, _marked[3], this);
}

/**
 *
 */
function watchRemoteCreateSuccess() {
	return regeneratorRuntime.wrap(function watchRemoteCreateSuccess$(_context5) {
		while (1) {
			switch (_context5.prev = _context5.next) {
				case 0:
					_context5.next = 2;
					return (0, _reduxSaga.takeEvery)(messagesActions.REMOTE_CREATE_SUCCESS, publishCreationWorker);

				case 2:
				case 'end':
					return _context5.stop();
			}
		}
	}, _marked[4], this);
}

/**
 *
 */
function watchLoadMessagesWorker() {
	return regeneratorRuntime.wrap(function watchLoadMessagesWorker$(_context6) {
		while (1) {
			switch (_context6.prev = _context6.next) {
				case 0:
					_context6.next = 2;
					return (0, _reduxSaga.takeEvery)(messagesActions.LOAD_MESSAGES, loadMessagesWorker);

				case 2:
				case 'end':
					return _context6.stop();
			}
		}
	}, _marked[5], this);
}